import service from '@/utils/request'

// 道具相关接口
export const getPropList = (data) => {
    return service({
        url: '/prop/list',
        method: 'post',
        data
    })
}
// 道具相关接口
export const getPropAllList = (data) => {
    return service({
        url: '/prop/all-list',
        method: 'post',
        data
    })
}

// 分类ID
export const getPropTypeList = (data) => {
    return service({
        url: '/prop/types',
        method: 'post',
        data
    })
}


// 更新道具
export const updateProp = (data) => {
    return service({
        url: '/prop/update',
        method: 'post',
        data
    })
}

// 创建道具
export const createProp = (data) => {
    return service({
        url: '/prop/create',
        method: 'post',
        data
    })
}



// 发放道具
export const distribute = (data) => {
    return service({
        url: '/prop/distribute',
        method: 'post',
        data
    })
}



//

// 获取免费游戏商户列表
export const getFreeGameMerchants = (data) => {
    return service({
        url: '/prop/freespin/merchants',
        method: 'post',
        data
    })
}

// 获取免费游戏游戏列表
export const getFreeGameGames = (data) => {
    return service({
        url: '/prop/freespin/games',
        method: 'post',
        data
    })
}

// 获取免费旋转规则(投注范围等)
export const getFreespinRules = (data) => {
    return service({
        url: '/prop/freespin/rules',
        method: 'post',
        data
    })
}


//
export const distributeDetails = (data) => {
    return service({
        url: '/prop/distribute-details',
        method: 'post',
        data
    })
}

// 获取活动中心列表
export const getActivityCenterList = (data) => {
    return service({
        url: '/uActivity/getActivityCenterList',
        method: 'post',
        data
    })
}

// 更新活动中心配置
export const updateActivityCenter = (data) => {
    return service({
        url: '/uActivity/updateActivityCenter',
        method: 'post',
        data
    })
}

// 导入救济金配置用户编号
export const importReliefConfigUserNo = (data) => {
    return service({
        url: '/uActivity/importReliefConfigUserNo',
        method: 'post',
        data
    })
}


// 保持抽奖和宝箱的 设置
export const setBoxSettings = (data) => {
    return service({
        url: '/uActivity/setAgentLotteryConfig',
        method: 'post',
        data
    })
}
export const getBoxSettings = (data) => {
    return service({
        url: '/uActivity/getAgentLotteryConfig',
        method: 'post',
        data
    })
}

export const getAgentLotteryList = (data) => {
    return service({
        url: '/uActivity/getAgentLotteryList',
        method: 'post',
        data
    })
}
export const getAgentBoxLotteryList = (data) => {
    return service({
        url: '/uActivity/getAgentBoxLotteryList',
        method: 'post',
        data
    })
}